module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.11@core-js/library/modules/_add-to-unscopables.js
// module id = 72
// module chunks = 0